import axios from "axios";
import config from "./config";
import state from "./state";
let auth = {
    async resetPassword(id, email, password) {
        try {
            let reply = await axios.post(config.app_url == undefined
                ? ""
                : config.app_url + "auth/reset-password", { id, email, password });
            return reply.data;
        }
        catch (error) {
            return false;
        }
    },
    async loginWithEmailAndPassword(email, password, scope) {
        try {
            let { data: token } = await axios.post(config.app_url == undefined ? "" : config.app_url + "auth/login", { email, password, scope });
            window.localStorage.setItem("openkit", token);
            return true;
        }
        catch (error) {
            return false;
        }
    },
    async loginWithToken() {
        try {
            let oldToken = window.localStorage.getItem("openkit");
            if (!oldToken) {
                // If no token is saved, return false
                return false;
            }
            let { data: newToken } = await axios.post(config.app_url == undefined ? "" : config.app_url + "auth/login", "", {
                headers: { Authorization: "Bearer " + oldToken },
            });
            window.localStorage.setItem("openkit", newToken);
            return true;
        }
        catch (error) {
            console.log(error);
            return false;
        }
    },
    async loginWithGoogleToken(googleToken) {
        try {
            let { data: openkitToken } = await axios.post(config.app_url == undefined ? "" : config.app_url + "auth/login-google", "", {
                headers: { Authorization: "Bearer " + googleToken },
            });
            window.localStorage.setItem("openkit", openkitToken);
            return true;
        }
        catch (error) {
            console.log(error);
            return false;
        }
    },
    async loginWithFacebookToken(facebookToken) {
        try {
            let { data: openkitToken } = await axios.post(config.app_url == undefined
                ? ""
                : config.app_url + "auth/login-facebook", "", {
                headers: { Authorization: "Bearer " + facebookToken },
            });
            window.localStorage.setItem("openkit", openkitToken);
            return true;
        }
        catch (error) {
            console.log(error);
            return false;
        }
    },
    async loginDevelopment() {
        const email = process.env.VUE_APP_OPENKIT_USERNAME;
        const password = process.env.VUE_APP_OPENKIT_PASSWORD;
        await auth.loginWithEmailAndPassword(email, password, ""); // fix later
        state.current_user = await auth.getLoggedInUser();
        if (state.current_user && state.current_user.client_id) {
            state.current_client = await this.getClient(state.current_user.client_id);
        }
        else if (state.current_user.selected_client_id) {
            state.current_client = await this.getClient(state.current_user.selected_client_id);
        }
        else {
            state.current_client = null;
        }
    },
    async getLoggedInUser() {
        try {
            let { data: user } = await axios.get(config.app_url == undefined ? "" : config.app_url + "auth/user", {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return user;
        }
        catch (error) {
            return null;
        }
    },
    async getClient(client_id) {
        try {
            let token = window.localStorage.getItem("openkit");
            let { data: client } = await axios.get(config.app_url == undefined
                ? ""
                : config.app_url + "data/clients/" + client_id, {
                headers: { Authorization: "Bearer " + token },
            });
            return client;
        }
        catch (error) {
            return null;
        }
    },
    logout() {
        window.localStorage.removeItem("openkit");
    },
};
export default auth;
